import Vue from 'vue';
window.Vue = Vue
require('../_bootstrap');
window._ = require('lodash');
import MaskedInput from 'vue-masked-input';
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead';
import Recaptcha from './GoogleReCaptchaV3';
import BootstrapVue from 'bootstrap-vue';
import axios from 'axios';
import {required, email} from 'vuelidate/lib/validators'
import Vuelidate from 'vuelidate'

Vue.use(Vuelidate);
Vue.use(BootstrapVue);

const app = new Vue({
    el: '#abonnents',
    components: {
        MaskedInput, VueBootstrapTypeahead, Recaptcha
    },
    validations: {
        personal: {
            objective: {required},
            company: {required},
            last_name: {required},
            first_name: {required},
            country: {required},
            address: {required},
            postcode: {required},
            city: {required},
            email: {required, email},
            project: {required},
            no_google_bing: {required},
        },
    },
    data() {
        let objective = Object.entries(window.Data.objective).map(function (entry) {
            return {value: entry[0], text: entry[1]}
        })
        objective.unshift({value: null, text: 'Objectif'});

        return {
            display: 'abonnementDisplay',
            countries: window.Data.countries,
            objective: objective,
            plan_name: window.Data.plan_name,
            personal: {
                country: '',
                email: '',
                abonnement: '',
                plan: window.Data.plan,
                objective: null,
                postcode: '',
                address: '',
                city: '',
                bing: '',
                google: '',
                company: '',
                first_name: '',
                last_name: '',
                project: '',
                no_google_bing: false,
                cgv: false,
                rgpd_email: false,
                is_rgpd: false
            },
            errorRGPD: false,
            errorCGV: false,
        }
    },
    mounted() {
        // this.objective.push({ value: null, text: 'Objectif'});
    },
    computed: {
        nothingIds() {
            return !!(this.personal.google || this.personal.bing);

        },
        validateForm() {
            return this.personal.cgv
                && this.personal.is_rgpd
                && this.personal.country
                && this.personal.email
                && this.personal.objective
                && this.personal.postcode
                && this.personal.address
                && this.personal.city
                && this.personal.company
                && this.personal.first_name
                && this.personal.last_name
                && this.personal.project
        }
    },
    methods: {
        inputLastName(event) {
            let val = event.target.value.match(/[A-Za-z\s-]+/);
            if (val) {
                this.personal.last_name = event.target.value = val[0];
            }
        },
        inputFirstName(event) {
            let val = event.target.value.match(/[A-Za-z\s-]+/);
            if (val) {
                this.personal.first_name = event.target.value = val[0];
            }
        },
        clickAbonnement(stripe_product) {
            this.personal.abonnement = stripe_product;
            this.changeDisplay('inputs');
        },
        submit() {
            if (this.validateForm) {
                axios.post('/souscription-offre/' + this.plan_name + '/store', {
                    personal: this.personal
                }).then(response => {
                    location.href = '/souscription-offre/' + response.data.plan + '/step_2'
                });
            } else {
                if (this.$v.$invalid) {
                    let inputs = document.querySelectorAll('.required-input');
                    const borderSuccess = 'border border-success';
                    const borderDanger = 'border border-danger';
                    _.each(inputs, function (item) {
                        let val = !!$(item).find('input').val() ? !$(item).find('input').val(): !$(item).val();
                        if (val) {
                            let inp = $(item);
                            inp.removeClass(borderSuccess)
                                .addClass(borderDanger)
                                .on('keypress', () => {
                                    inp.removeClass(borderDanger).addClass(borderSuccess)
                                })
                                .on('change', () => {
                                    inp.removeClass(borderDanger).addClass(borderSuccess)
                                })
                        } else {
                            $(item).removeClass(borderDanger).addClass(borderSuccess)
                        }
                    });

                    $('#modal').modal('show');
                }
                this.errorCGV = !this.personal.cgv;
                this.errorRGPD = !this.personal.cgv;
            }
        },
        checkedCGV() {
            this.errorCGV = this.personal.cgv !== true;
        },
        checkedRGPD() {
            this.errorRGPD = this.personal.is_rgpd !== true;
        },
        changeDisplay(display) {
            this.display = display;
        }
    }
});
